<template>
  <div v-if="loading" class="text-center font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" />
  </div>

  <div v-else class="animated">
    <div>
      <AnalyteRangeFormSoilEdit
        :analyte_ranges="analyte_ranges"
        :loading_analyte_ranges="loading_analyte_ranges"
        @refresh="fetchAnalyteRanges"
      />

      <b-card v-if="addingNew" no-body>
        <b-card-header>
          <span class="text-muted text-uppercase">Add Analyte Range</span>
        </b-card-header>

        <b-card-body>
          <AnalyteRangeFormSoilAdd
            :analyte="analyte"
            @close="addingNew = false"
            @saved="onSave"
          />
        </b-card-body>
      </b-card>

      <b-button v-else block variant="primary" @click="addingNew = true">
        <i class="fa fa-plus" /> Add Analyte Range
      </b-button>
    </div>
  </div>
</template>

<script>
import { getCollection } from '@/shared/fetch-utils'
import AnalyteRangeFormSoilEdit from './fields/AnalyteRangeFormSoilEdit.vue'
import AnalyteRangeFormSoilAdd from './fields/AnalyteRangeFormSoilAdd.vue'

export default {
  name: 'AnalyteRangeFormSoil',
  components: {
    AnalyteRangeFormSoilEdit,
    AnalyteRangeFormSoilAdd
  },
  props: {
    analyte: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      loading: true,
      analyte_id: this.analyte.id,

      loading_analyte_ranges: true,
      analyte_range_collection: null,
      analyte_ranges: [],

      addingNew: false,
    }
  },
  async created () {
    this.loading = true

    await this.fetchAnalyteRanges()

    this.loading = false
  },
  methods: {
    async fetchAnalyteRanges () {
      this.loading_analyte_ranges = true

      this.analyte_range_collection = await getCollection({
        collection_type: 'analyte_range',
        filters: [
          {
            logic: 'filterEquals',
            field: 'analyte_id',
            value: this.analyte_id
          }
        ]
      })

      this.analyte_ranges = this.analyte_range_collection.map((analyte_range) => {
        return {
          id: analyte_range.id,
          analyte: analyte_range.analyte,
          analyte_id: analyte_range.analyte_id,
          irrigated: analyte_range.irrigated == null ? false : analyte_range.irrigated,
          very_low: analyte_range.very_low,
          low: analyte_range.low,
          high: analyte_range.high
        }
      })

      this.loading_analyte_ranges = false
    },

    onSave () {
      this.addingNew = false
      this.fetchAnalyteRanges()
    }
  }
}
</script>
